export default __webpack_public_path__ + "static/media/too_easy.0f0bba61.svg";